import $ from 'jquery';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form, { FormField } from '../../common/Form';
import Link from '../../common/Link';
import { getAuth } from '../../services/AuthService';
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';
import TabletNavbar from './TabletNavbar';
import { getNavbar, NavbarItem } from '../Navbar';
import { MenuResponseJSON } from '../../helpers/interfaces';

type Props = {
  menu: MenuResponseJSON
}

export function Header(props: Props) {
  const navigate = useNavigate();
  const auth = getAuth();
  const [navbar, setNavbar] = useState<NavbarItem[]>([]);
  
  useEffect(() => {
    
    (async function() {
      const navBar = await getNavbar(props.menu);

      setNavbar(navBar);
    })();
  }, [props.menu]);

  function searchHandler(values: any) {
    navLinkClickHandler('navbar-search-link', 'navbar-search');
    navigate('/ricerca?q=' + encodeURIComponent(values.search_input));
  }

  const searchFormFields: Array<FormField> = [
    {
      id: 'search_input',
      name: 'search_input',
      type: 'text',
      placeholder: "Ricerca"
    }
  ];

  function navLinkClickHandler(linkId: string, elementId: string) {
    const newClassText = ' collapsed';
    const link = document.querySelector(`#${linkId}`);
    const linkClass = link?.getAttribute('class');
    const newLinkClass = linkClass?.replaceAll(newClassText, '');
    newLinkClass && link?.setAttribute('class', (newLinkClass ? newLinkClass : '') + newClassText);
    link?.setAttribute('aria-expanded', 'false');

    const element = document.querySelector(`#${elementId}`);
    const elementClass = element?.getAttribute('class');
    const newClassName = elementClass?.replace(' show', '');

    newClassName && element?.setAttribute('class', newClassName);
  }

  function mobileCollapse() {
    var win = $(window);
    var width = win.width();
    if (typeof width !== 'undefined') {
      if (width > 991) {
        $('.navbar-collapse').removeClass('navbar-collapse-mobile');
        $('.navbar-collapse > ul.navbar-nav > li.nav-item a[data-bs-toggle="dropdown"]').addClass('dropdown-toggle')
      } else {
        $('.navbar-collapse').addClass('navbar-collapse-mobile');
        $('.navbar-collapse > ul.navbar-nav > li.nav-item a[data-bs-toggle="dropdown"]').removeClass('dropdown-toggle')
      }
    }
  }

  useEffect(() => { mobileCollapse() }, []);

  $(window).on('resize', function () {
    mobileCollapse()
  });

  return (
    <header>
      <nav id="header-navbar" className="navbar navbar-expand-lg navbar-dark bg-dark m-auto" suppressHydrationWarning>
        <div className="w-100 m-auto d-lg-flex align-items-lg-center px-3 position-relative">
          <Link className="navbar-brand" href="/" onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}>
            <span id="navbar-logo">
              <img
                className="d-none d-lg-inline"
                alt="Desktop logo"
                src="/C5LiveDesktop.png"
                width="225"
                height="45"
              />
              <img
                className="d-inline d-lg-none"
                alt="Mobile logo"
                src="/C5LiveMobile.png"
                width="45"
                height="45"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse-mobile.show"
              />
            </span>
          </Link>
          <div className="d-flex d-md-contents float-xxs-end">
            <div id="navbar-actions" className="navbar-nav flex-row d-inline-flex me-3 me-lg-0 order-lg-last justify-content-between">
              <div className='nav-item dropdown'>
                <Link
                  id="navbar-search-link"
                  href="#search"
                  title="Cerca su CalcioA5Live"
                  isDropdown
                  className={'nav-link p-2 collapsed'}
                  role="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbar-search"
                  aria-controls="navbar-search"
                  aria-expanded="false"
                  onClick={() => navLinkClickHandler('navbarSupportedLink', 'navbarSupportedContent')}
                >
                  <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="17.5" cy="18" r="17.5" fill="#F9F9F9" />
                    <path d="M21.9438 20.7834C22.8828 19.5049 23.4375 17.9266 23.4375 16.2188C23.4375 11.9558 19.9817 8.5 15.7188 8.5C11.4558 8.5 8 11.9558 8 16.2188C8 20.4817 11.4558 23.9375 15.7188 23.9375C17.4271 23.9375 19.0058 23.3825 20.2844 22.4431L20.2834 22.4438C20.3184 22.4913 20.3574 22.5368 20.4004 22.5798L24.9728 27.1522C25.4366 27.6159 26.1884 27.6159 26.6522 27.1522C27.1159 26.6884 27.1159 25.9366 26.6522 25.4728L22.0798 20.9004C22.0368 20.8574 21.9913 20.8184 21.9438 20.7834ZM22.25 16.2188C22.25 19.8259 19.3259 22.75 15.7188 22.75C12.1116 22.75 9.1875 19.8259 9.1875 16.2188C9.1875 12.6116 12.1116 9.6875 15.7188 9.6875C19.3259 9.6875 22.25 12.6116 22.25 16.2188Z" fill="black" />
                  </svg>
                </Link>
              </div>
            </div>
            <TabletNavbar navLinkClickHandler={navLinkClickHandler} navbar={navbar} />
            <MobileNavbar navLinkClickHandler={navLinkClickHandler} navbar={navbar} />
          </div>
          <div id="navbar-search" className="collapse px-2">
            <Form
              id="search-form"
              formFields={searchFormFields}
              onSubmit={searchHandler}
              submitText={
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.3342 14.3891C17.4342 12.8915 18.0839 11.0426 18.0839 9.04196C18.0839 4.04823 14.0357 0 9.04196 0C4.04823 0 0 4.04823 0 9.04196C0 14.0357 4.04823 18.0839 9.04196 18.0839C11.0431 18.0839 12.8925 17.4338 14.3903 16.3333L14.3891 16.3342C14.4301 16.3898 14.4758 16.4431 14.5262 16.4934L19.8824 21.8497C20.4257 22.393 21.3065 22.393 21.8497 21.8497C22.393 21.3065 22.393 20.4257 21.8497 19.8824L16.4934 14.5262C16.4431 14.4758 16.3898 14.4301 16.3342 14.3891ZM16.6929 9.04196C16.6929 13.2674 13.2674 16.6929 9.04196 16.6929C4.81649 16.6929 1.39107 13.2674 1.39107 9.04196C1.39107 4.81649 4.81649 1.39107 9.04196 1.39107C13.2674 1.39107 16.6929 4.81649 16.6929 9.04196Z" fill="#F9F9F9" />
                </svg>
              }
            />
          </div>
          <DesktopNavbar navLinkClickHandler={navLinkClickHandler} navbar={navbar} />
        </div>
      </nav>
    </header>
  );
}